import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AttachingCertificateComponent, SpecificationsDataDownloadComponent } from 'src/app/components/dialog';
import { ProductsAttributesEditComponent } from 'src/app/components/dialog/attributes/products-attributes-edit/products-attributes-edit.component';
import { FileToCategoryComponent } from 'src/app/components/dialog/files/file-to-category/file-to-category.component';
import { ProductsDataDownloadComponent } from 'src/app/components/dialog/files/products-data-download/products-data-download.component';
import { ActionsList } from 'src/app/models';
import { ApiOrganizationsService, DialogModalService, FilesService, NotificationService, PermissionService } from 'src/app/services';

@Component({
  selector: 'ff-actions-menu',
  templateUrl: './ff-actions-menu.component.html',
  styleUrls: ['./ff-actions-menu.component.css']
})
export class FfActionsMenuComponent implements OnInit {

  currentOrgData: any;

  @Input() configuredAttirubes: string[] = [];
  @Input() countSelectedFiles: string;
  @Input() actionListData: any;
  @Input() listData: any[] = [];
  @Input() ids:any[] = [];
  @Input() selectedFiles: string;

  @Output() changeValue = new EventEmitter();
  @Output() deletedData = new EventEmitter();


  constructor(
    private notification: NotificationService,
    private dialogModal: DialogModalService,
    public permissionAccessService: PermissionService,
    private fileService: FilesService,
    private apiOrganizationsService: ApiOrganizationsService
  ) { }

  ngOnInit(): void {

    this.currentOrgData = this.apiOrganizationsService.currentOrganization;
    this.checkState();
  }

  ngOnDestroy() {

  }

  /**
   * 
   * @param id 
   * @param action 
   */
  getAction(id: string) {

    switch (id) {

      case 'add_to_category':
        this.addFileToCategory();
        break;

      case 'download_product_files':
        this.downloadProductData();
        break;

      case 'attritube_edit':
        this.attrsEdit();
        break;

      case 'certificate':
        this.openDialogAttachingCertificate();
        break;

      case 'delete_selected':
        this.deleteSelected();
        break;

      case 'spicification_unload':
        this.downloadSpecificationsData();
        break;

      case 'download_selected':
        this.downloadMediaFiles();
        break;

      default:
        this.notification.show('success', 'Запрашиваемое действие неопределено!');
        break;
    }
  }

  /**
    * 
    * @returns boolean
    */
  checkState(): any {

    let filtereList = this.actionListData.filter(val => this.permissionAccessService.check(val.action));

    this.actionListData = filtereList != undefined && filtereList != null ? filtereList : [];

  }


  /**
   * 
   */
  addFileToCategory() {

    let data = {

      file_ids: this.ids.length > 0  ? this.ids : [...new Set(this.listData.filter(val => val.checked).map(({ id }) => id))]
    }

    this.dialogModal.open(data, FileToCategoryComponent).then(
      (result) => {

        if (result) {

          this.changeValue.emit(true);
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  downloadMediaFiles() {

    let ids: string[] = [...new Set(this.listData.filter(val => val.checked).map(({ id }) => id))];
    let name: string[] = [...new Set(this.listData.filter(val => val.checked).map(({ name }) => name))];
    let data = {
      id: ids
    }

    // this.fileService.downloadMediaFiles(data, name);
    // this.fileService.downloadWithSettings('downloadWithSettings', data)
    this.fileService.downloadSelectedFile(ids)
  }

  /**
  * 
  */
  downloadProductData() {

    let data = {
      org_id: this.currentOrgData.id,
      product_ids: this.ids.length > 0  ? this.ids : this.listData.filter(val => val.checked).map(({ id }) => id),
      attrs_for_table: this.configuredAttirubes.length ? this.configuredAttirubes : []
    }

    this.dialogModal.open(data, ProductsDataDownloadComponent, '', 'uploadSetting-window').then(
      (result) => {

        if (result) {


        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
  * 
  */
  downloadSpecificationsData() {

    let data = {
      org_id: this.currentOrgData.id,
      product_ids: this.ids.length > 0  ? this.ids : this.listData.filter(val => val.checked).map(({ id }) => id)
    }

    this.dialogModal.open(data, SpecificationsDataDownloadComponent, '', 'uploadSetting-window').then(
      (result) => {

        if (result) {


        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
* 
*/
  attrsEdit()  {

    let data = {
      product_ids: this.ids.length > 0 ? this.ids : [...new Set(this.listData.filter(val => val.checked).map(({ id }) => id))]
    }

    this.dialogModal.open(data, ProductsAttributesEditComponent, '', 'attr-window').then(
      (result) => {

        if (result) {

          this.changeValue.emit(true);
        }
      },
      () => { console.log('Rejected!'); }
    );
  }


  /**
  * 
  */
  openDialogAttachingCertificate(): void {

    let data = {
      type: 'attach',
      cert_type: '',
      product_ids: this.ids.length > 0  ? this.ids : [...new Set(this.listData.filter(val => val.checked).map(({ id }) => id))]
    }

    this.dialogModal.open(data, AttachingCertificateComponent).then(
      (result) => {

        if (result) {

          this.changeValue.emit(true);
        }
      },
      () => { console.log('Rejected!'); }
    );
  }

  /**
   * 
   */
  deleteSelected(): void {

    let ids = this.ids.length > 0  ? this.ids : [...new Set(this.listData.filter(val => val.checked).map(({ id }) => id))];
    this.deletedData.emit(ids);
  }
}
